var map = {
	"./Copy of _MG_4268.jpg": 525,
	"./Copy of _MG_4744.jpg": 814,
	"./DSC07726.JPG": 800,
	"./Hacking.mp4": 823,
	"./IMG_2431.jpg": 495,
	"./Stellar-243.jpg": 272,
	"./Stellar-249.jpg": 434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 561;